import { render } from "./ItemSalesByGroupDailyReport.vue?vue&type=template&id=0424f2cb&scoped=true"
import script from "./ItemSalesByGroupDailyReport.vue?vue&type=script&lang=js"
export * from "./ItemSalesByGroupDailyReport.vue?vue&type=script&lang=js"

import "./ItemSalesByGroupDailyReport.vue?vue&type=style&index=0&id=0424f2cb&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0424f2cb"]])

export default __exports__